$('input').focus(function () {
    $(this).parents('.form-group').addClass('input-focused');
});

$('input').blur(function () {
    var inputValue = $(this).val();
    if (inputValue == "") {
        $(this).removeClass('filled');
        $(this).parents('.form-group').removeClass('input-focused');
    } else {
        $(this).addClass('filled');
    }
}) 